export const errorBoundary = {
  errorBoundaryAPPMessage1: "Oops! Something went wrong",
  errorBoundaryAPPMessage2: "We are fixing it, please try to reload the page",

  errorBoundaryRedirect1: "Oops! Something went wrong",
  errorBoundaryRedirect2: "We are fixing it, click the button to go back",

  errorBoundaryHandler1: "Oops! Something went wrong",
  errorBoundaryHandler2: "Try to reload this section",

  errorBoundaryBtnReload: "Reload",
  errorBoundaryBtnHome: "Back",
};
